(function () {
    'use strict';

    function init() {
        const containers = document.querySelectorAll('.js-featured-posts');
        if (!containers) return;

        containers.forEach((container) => {
            const context = container.dataset.context;
            const itemsCount = container.style.getPropertyValue('--items-count');

            setupSwiper('.js-featured-posts-carousel', {
                root: container,
                containerSelector: '.js-featured-posts',
                jsSelector: '.js-featured-posts-carousel',
                swiperOptions: {
                    slidesPerView: itemsCount > 1 ? 1.1 : 1,
                    spaceBetween: 12,
                    breakpoints: 'fullwidth' === context ? {
                        744: { slidesPerView: 2.1 },
                        1280: { slidesPerView: 3.1 },
                        1400: { slidesPerView: 4 },
                    } : {
                        744: { slidesPerView: 2 },
                        1280: { slidesPerView: 3 },
                    },
                }
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();